import React, { memo, useEffect } from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';

import { Card, CardContent, MuiTitle } from 'src/ui/mui-ui-kit';;
import { clearBreadcrumbs } from 'src/ui';

function OverviewPage({ clearBreadcrumbs }) {
  useEffect(() => {
    clearBreadcrumbs();
  }, []);

  return (
    <Card>
      <CardContent>
        <MuiTitle hasTextColor="info" isSize="4">
          Complete Onboarding
        </MuiTitle>
      </CardContent>
    </Card>
  );
}

OverviewPage.propTypes = {
  clearBreadcrumbs: propTypes.func.isRequired,
};

const memoizedOverviewPage = memo(OverviewPage);

const connectedOverviewPage = connect(
  null,
  {
    clearBreadcrumbs,
  }
)(memoizedOverviewPage);

export { connectedOverviewPage as OverviewPage };
